import { getCompPathParentInfo } from "../../../lib/utils";
import { arrayify } from "../../../lib/utils/array";
import { getOffsetRect } from "../../../lib/utils/styling";
import DropHint from './base';
import { genNbsp } from "../../../lib/designer/utils/generatorNbsp";
import { getBaseLayout } from "../../../lib/designer/utils/layout";
const HINT_SIZE = 24;
const MIN_HINT_LENGTH = HINT_SIZE * 3;
export default class BlockifyDropHint extends DropHint {
  constructor() {
    super(...arguments);
    this.hintClassName = '';
  }
  getRect() {
    var _this$renderer$getRef;
    const {
      compPath,
      place
    } = this.config;
    const refElement = (_this$renderer$getRef = this.renderer.getRefByPath(compPath)) === null || _this$renderer$getRef === void 0 ? void 0 : _this$renderer$getRef.$el;
    if (!refElement) return null;
    const {
      x: x0,
      y: y0,
      width: w0,
      height: h0
    } = getOffsetRect(refElement, this.ownerSlot.slotContainerElement);
    const after = place === 'after';
    return {
      x: x0,
      y: y0 + (after ? h0 : -HINT_SIZE),
      width: w0,
      height: HINT_SIZE
    };
  }
  getDescription() {
    const rect = this.getRect();
    if (rect) {
      const {
        width,
        height
      } = rect;
      if (Math.max(width, height) < MIN_HINT_LENGTH) {
        return genNbsp(6);
      }
    }
    return `放${this.config.place === 'before' ? '上面' : '下面'}`;
  }
  getRelatedCompPath() {
    return this.config.compPath;
  }
  async execute() {
    var _uc$components$anchor;
    const {
      designer,
      config,
      uc
    } = this;
    const {
      place
    } = config;
    const dragSource = designer.dragSource;
    const oldDraggingBlockPath = this.editZoneState.currentDraggingCompPath; // 如果是页面内拖拽（不是外部拖入），则这个有值
    /** 放置的新对象 */
    const newItem = dragSource.layout;
    const newItemList = arrayify(newItem);
    /** 放置参考点 */
    const anchorPath = config.compPath; // 当前 DropHint 是挂在哪个组件上的（锚点）
    const anchorPathInfo = getCompPathParentInfo(anchorPath);
    if (!anchorPathInfo) return; // 奇怪的边界情况，一般应该到不了
    /** 参考点的对象 */
    let anchor = designer.getCompAtPath(anchorPath);
    // 如果当前参考点是一个行组件，则为他套 w-paragraph
    if (((_uc$components$anchor = uc.components[anchor.type]) === null || _uc$components$anchor === void 0 ? void 0 : _uc$components$anchor.display) === 'inline') {
      anchor = getBaseLayout(uc, 'paragraph', [anchor]);
    }
    // 把当前锚点的组件，替换为一个 w-block
    {
      const block = getBaseLayout(uc, 'block', place === 'before' ? [...newItemList, anchor] : [anchor, ...newItemList], {
        style: {
          alignSelf: 'stretch'
        }
      });
      const newItemPath = `${anchorPath}/default/${place === 'before' ? 0 : 1}`;
      await designer.spliceComp([anchorPath, oldDraggingBlockPath], anchorPath,
      // 然后将现在锚点组件位置，放入新建的 row
      block);
      designer.compPath = newItemPath;
    }
  }
}
//# sourceMappingURL=BlockifyDropHint.js.map
